import React, { useEffect, useRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Cancel, Delete } from '@mui/icons-material';
import { Box, Divider, Grid, Modal, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { toast } from 'react-hot-toast';

const SeoInputDialog = ({ open, onClose, onSave, seoDetails, seoImages, offering_id, onUpdate, onDelete, setSeoData, seoData }) => {
    const [title, setTitle] = useState('');
    const [keywords, setKeywords] = useState('');
    const [description, setDescription] = useState('');
    const [shareImg, setShareImg] = useState('');
    const [shareImgFile, setShareImgFile] = useState(null);
    const [seoImageModalOpen, setSeoImageModalOpen] = useState(false)
    const useImgRef = useRef(null)

    useEffect(() => {
        if (seoDetails) {
            setTitle(seoDetails?.title)
            setKeywords(seoDetails?.keywords)
            setDescription(seoDetails?.description)
            setShareImg(seoDetails?.share_image);
            setShareImgFile(seoDetails?.share_image);
            setSeoData({
                rating_count: seoData?.rating_count,
                rating_value: seoData?.rating_value,
                review_count: seoData?.review_count,
                brand_name: seoData?.brand_name
            })
        }
        if (!open) {
            setTitle('');
            setKeywords('');
            setDescription('');
            setShareImg('');
        }
    }, [open]);

    const handleSave = () => {
        if (!offering_id || !title.trim() || !keywords.trim() || !description.trim() || !seoData?.rating_count || !seoData?.rating_value || !seoData?.review_count || !seoData?.brand_name) {
            toast.error('Please fill in all the required fields.');
            return;
        }
        // debugger
        const formData = new FormData();
        formData.append("title", title);
        formData.append("keywords", keywords);
        formData.append("description", description);
        formData.append("rating_count", seoData?.rating_count);
        formData.append("rating_value", seoData?.rating_value);
        formData.append("review_count", seoData?.review_count);
        formData.append("brand_name", seoData?.brand_name);
        formData.append("offering_id", offering_id);
        if (shareImgFile) formData.append("share_image", shareImgFile);

        onSave(formData);
        // debugger
        onClose();
        setSeoData({
            rating_count: '',
            rating_value: '',
            review_count: '',
            brand_name: ''
        });
    };

    const handleUpdate = () => {
        if (!title.trim() || !keywords.trim() || !description.trim() || !seoData?.rating_count || !seoData?.rating_value || !seoData?.review_count || !seoData?.brand_name) {
            toast.error('Please fill in all the required fields.');
            return;
        }
        const formData = new FormData();
        formData.append("title", title);
        formData.append("keywords", keywords);
        formData.append("description", description);
        formData.append("brand_name", seoData?.brand_name);
        formData.append("rating_count", seoData?.rating_count);
        formData.append("rating_value", seoData?.rating_value);
        formData.append("review_count", seoData?.review_count);
        formData.append("offering_id", offering_id);
        if (shareImgFile) formData.append("share_image", shareImgFile);
        onUpdate(formData);
        onClose();
    };

    const handleDelete = () => {
        onDelete({ offering_id });
        onClose();
        toast.success('SEO details deleted successfully')
        setSeoData({
            rating_count: '',
            rating_value: '',
            review_count: '',
            brand_name: ''
        })
    };

    const handleImageChange = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = function () {
                    if ((this.width < 400 && this.width >= 200) || (this.height < 400 && this.height >= 200)) {
                        alert('Image dimensions should be at least 200px x 200px.');
                    } else if ((file?.size / 1024) > 25) {
                        alert('Image size should be less than or equal to 25KB.');
                    } else {
                        setShareImgFile(file);
                        setShareImg(event.target.result);
                    }
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const handleInputSeoDataChange = (event, field) => {
        const { value } = event.target;
        setSeoData((prevData) => ({
            ...prevData,
            [field]: value
        }));
    }

    const style = {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        height: 530,
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: "8px",
        p: 4,
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 20px" }}>
                <DialogTitle>SEO Details</DialogTitle>
                <ClearIcon onClick={onClose} color="error" variant='contained' sx={{ cursor: "pointer" }} />
            </div>
            <Divider sx={{ border: "3px solid black", padding: "0px" }} />
            <DialogContent>
                <div style={{ display: "flex", gap: "20px" }}>
                    <TextField
                        margin="dense"
                        label="Offering Id"
                        fullWidth
                        value={offering_id}
                        disabled

                    />
                    <TextField
                        autoFocus={!seoDetails}
                        margin="dense"
                        label="Title"
                        fullWidth
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                </div>
                <div style={{ display: "flex", gap: "20px" }}>
                    <div>
                        <TextField
                            margin="dense"
                            label="Brand Name"
                            fullWidth
                            value={seoData?.brand_name || ''}
                            onChange={(e) => handleInputSeoDataChange(e, 'brand_name')}
                        />
                    </div>
                    <div>
                        {/* Field 1: The Average Score */}
                        <TextField
                            margin="dense"
                            label="Enter Rating Value"
                            fullWidth
                            value={seoData?.rating_value || ''}
                            onChange={(e) => handleInputSeoDataChange(e, 'rating_value')}
                        />
                        <small style={{ display: 'block', color: 'grey', fontSize: '14px' }}>
                            Must be a value between 1 and 5 (e.g., 4.2, 4.8).
                        </small>
                    </div>
                </div>
                <div style={{ display: "flex", gap: "20px" }}>
                    <div>
                        {/* Field 2: The Total Number of Ratings (Votes) */}
                        <TextField
                            margin="dense"
                            label="Enter Rating Count"
                            fullWidth
                            value={seoData?.rating_count || ''}
                            onChange={(e) => handleInputSeoDataChange(e, 'rating_count')}
                        />
                        <small style={{ display: 'block', color: 'grey', fontSize: '14px' }}>
                            Must be a whole number (e.g., 615). Must be greater than or equal to Review Count.
                        </small>
                    </div>
                    <div>
                        {/* Field 3: The Number of Written Reviews */}
                        <TextField
                            margin="dense"
                            label="Enter Review Count"
                            fullWidth
                            value={seoData?.review_count || ''}
                            onChange={(e) => handleInputSeoDataChange(e, 'review_count')}
                        />
                        <small style={{ display: 'block', color: 'grey', fontSize: '14px' }}>
                            Must be a whole number (e.g., 600). Must be less than or equal to Rating Count.
                        </small>
                    </div>
                </div>
                <TextField
                    margin="dense"
                    label="Keywords"
                    fullWidth
                    value={keywords}
                    onChange={(e) => setKeywords(e.target.value)}
                />

                <TextField
                    margin="dense"
                    label="Description"
                    fullWidth
                    multiline
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
                <Grid item xs={12} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "20px" }}>
                    <Button variant='contained' onClick={() => { useImgRef.current.click() }} sx={{ backgroundColor: "#7469f1", "&:hover": { backgroundColor: "#7469f1" } }}>Upload Image</Button>
                    <input ref={useImgRef} hidden name='Offer share image' type='file' accept='image/*' onChange={handleImageChange} />
                    <div style={{ display: "flex" }}>
                        {shareImg && (
                            <div style={{ position: "relative" }}>
                                <img src={shareImg} alt="Share image" style={{ height: "50px", width: "50px", marginRight: "20px" }} />
                                <Cancel onClick={() => { setShareImgFile(null); setShareImg('') }} sx={{ position: "absolute", top: "0", left: "50%" }} />
                            </div>
                        )}
                    </div>
                    {seoImages?.data?.length > 0 && <Button onClick={() => { setSeoImageModalOpen(true); setShareImgFile('') }} style={{ margin: "5px 0px" }} variant='contained' sx={{ backgroundColor: "#7469f1", "&:hover": { backgroundColor: "#7469f1" } }}>Share Image </Button>}
                </Grid>
            </DialogContent>
            <div style={{ alignItems: "center" }}>
                <DialogActions style={{ display: "flex", justifyContent: "center", marginRight: "20px", alignItems: "center", gap: "10px" }}>
                    {seoDetails && <Delete onClick={handleDelete} color="primary" sx={{ color: "red", cursor: "pointer", "&:hover": { color: "red" } }} />}
                    {seoDetails ? (<Button onClick={handleUpdate} sx={{ backgroundColor: "#7469f1", color: "white", "&:hover": { backgroundColor: "#7469f1", color: "white" } }}>
                        Update
                    </Button>) : (
                        <Button onClick={handleSave} sx={{ backgroundColor: "#7469f1", color: "white", "&:hover": { backgroundColor: "#7469f1", color: "white" } }}>
                            Save
                        </Button>
                    )}
                </DialogActions>
            </div>
            <Modal
                open={seoImageModalOpen}
                onClose={() => setSeoImageModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography sx={{ display: "flex", justifyContent: "center", color: "#815B5B" }} id="modal-modal-title" variant="h6" component="h2">
                        Choose Image
                    </Typography>
                    <Grid container rowSpacing={1} sx={{ display: "flex", justifyContent: "center", maxHeight: 400, overflowY: 'auto' }} columnSpacing={2}>
                        {seoImages?.data?.length > 0 && seoImages?.data?.filter((el) => el?.includes("vms-images"))?.map((el, i) => {
                            return <Grid item xs={'auto'} key={i}>
                                <img src={el} alt="img" height={80} onClick={(e) => {
                                    setShareImg(e?.target?.src);
                                    const file = seoImages?.data[i];
                                    setShareImgFile(file);
                                    setSeoImageModalOpen(false);
                                }} style={{ objectFit: "contain", borderRadius: "10px" }} />
                            </Grid>
                        })}
                    </Grid>
                </Box>
            </Modal>
        </Dialog>
    );
};

export default SeoInputDialog;